import React from 'react';
import classNames from 'classnames';
import BootstrapContainer from 'react-bootstrap/Container';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const Container = ({ children = null, className = null, fluid = false }) => (
  <BootstrapContainer fluid={fluid} className={classNames('ws-ui-grid-container', className)}>
    {children}
  </BootstrapContainer>
);

export default Container;
